import { Route, Routes } from 'react-router-dom';
import * as routes from '../routing/routes';
import { Approval } from '../pages/Approval';
import { Confirmation } from '../pages/Confirmation';
import { Expiration } from '../pages/Expiration';
import { Home } from '../pages/Home';
import { OTP } from '../pages/OTP';

export const App = () => {
  return (
    <Routes>
      <Route path={routes.home} element={<Home />} />
      <Route path='/*' element={<Home />} />
      <Route path={routes.otp} element={<OTP />} />
      <Route path={routes.approval} element={<Approval />} />
      <Route path={routes.expiration} element={<Expiration />} />
      <Route path={routes.confirmation} element={<Confirmation />} />
      <Route path={routes.healthCheck} />
    </Routes>
  );
};
